import React from 'react';
import { Mail, Phone, User as UserIcon } from 'lucide-react';
import { useMeuGestor } from '../hooks';

const MeuGestorPage: React.FC = () => {
  const { data, isLoading, isError } = useMeuGestor();
  const manager = data?.manager ?? null;

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Meu Gestor</h1>

      {isLoading ? (
        <div>Carregando...</div>
      ) : isError ? (
        <div className="text-red-600">Erro ao carregar dados do gestor.</div>
      ) : manager ? (
        <div className="max-w-md bg-white rounded-xl border border-gray-200 shadow-sm p-6 space-y-4">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <UserIcon className="w-7 h-7 text-blue-600" />
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-900">{manager.name}</p>
              <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-purple-100 text-purple-700">
                Gestor
              </span>
            </div>
          </div>

          <div className="border-t border-gray-100 pt-4 space-y-3">
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <Mail className="w-4 h-4 text-gray-400 flex-shrink-0" />
              <span>{manager.email}</span>
            </div>
            {manager.phone && (
              <div className="flex items-center gap-3 text-sm text-gray-700">
                <Phone className="w-4 h-4 text-gray-400 flex-shrink-0" />
                <span>{manager.phone}</span>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="max-w-md bg-yellow-50 border border-yellow-200 rounded-xl p-6 text-center space-y-2">
          <UserIcon className="w-10 h-10 text-yellow-400 mx-auto" />
          <p className="text-sm font-medium text-yellow-800">Nenhum gestor atribuído ainda</p>
          <p className="text-xs text-yellow-600">Entre em contato com o administrador para ter um gestor designado.</p>
        </div>
      )}
    </div>
  );
};

export default MeuGestorPage;
